import AppLayout from '../../layouts/AppLayout/AppLayout';
import MainHeader from '../../Components/MainHeader/MainHeader';
import RecoveryPassword from '../../Components/Auth/RecoveryPassword/RecoveryPassword';
import MainFooter from '../../Components/MainFooter/MainFooter';

function RecoveryPasswordPage() {
    return (
        <AppLayout>
            <MainHeader variant="cabinet" />
            <main>
                <RecoveryPassword />
            </main>
            <MainFooter />
        </AppLayout>
    );
}

export default RecoveryPasswordPage;
